module.exports = __webpack_public_path__ + "static/media/save-svgrepo-com.3e1cac1f.svg";